<i18n lang="json">
  {
    "ru": {
      "Вакансии": "Вакансии",
      "Откликнуться": "Откликнуться",
      "Наши ожидания": "Наши ожидания"
    },
    "en": {
      "Вакансии": "Vacancies",
      "Откликнуться": "Apply",
      "Наши ожидания": "Our Expectations"
    },
    "tr": {
      "Вакансии": "İş İlanları",
      "Откликнуться": "Başvur",
      "Наши ожидания": "Beklentilerimiz"
    },
    "es": {
      "Вакансии": "Vacantes",
      "Откликнуться": "Postularse",
      "Наши ожидания": "Nuestras Expectativas"
    },
    "ar": {
      "Вакансии": "الوظائف",
      "Откликнуться": "التقديم",
      "Наши ожидания": "توقعاتنا"
    }
  }
</i18n>
<script setup>
import toStrapiLocale from "../helpers/toStrapiLocale";
const { $get } = useAxios();
const { locale } = useI18n();

const { t } = useI18n({ useScope: "local" });

const { data: vacancies } = await useAsyncData("get all vacancies", () =>
  $get(
    `/vacancies?_locale=${toStrapiLocale(locale.value)}&_sort=published_at:desc`
  )
);
</script>

<template>
  <section class="container mb-10 px-4 xl:px-0 mt-6 sm:mt-10">
    <div>
      <p
        class="text-base sm:text-4xl font-firasans mb-5 lg:mb-[30px] font-medium"
      >
        {{t('Вакансии')}}
      </p>
      <div
        class="w-full grid grid-cols-1 xl:grid-cols-2 gap-5"
        v-if="vacancies && vacancies.length"
      >
        <div
          v-for="vacancy in vacancies"
          :key="vacancy.id"
          class="sm:p-4 pt-2 rounded-[10px] sm:rounded-[20px] bg-[#FAFAFA] sm:grid sm:justify-between sm:gap-20"
          style="box-shadow: 0px 0px 4px 0px #00000040"
        >
          <div class="flex flex-col space-y-2 sm:flex-row sm:gap-20">
            <div class="px-2 sm:px-0 grid justify-items-stretch">
              <p class="text-base sm:text-xl font-sans font-semibold">
                {{ vacancy.title }}
              </p>
              <nuxt-link :to="localePath(`/vacancies?id=${vacancy.id}#vacancyForm`)" class="block mt-auto">
                <AButton
                  width="medium"
                  fontSize="lg"
                  class="hidden sm:block justify-end mt-auto font-medium"
                  >{{t('Откликнуться')}}</AButton
                >
              </nuxt-link>
            </div>

            <div class="px-2 sm:px-0 flex flex-col font-sans space-y-2">
              <p class="text-sm font-sans text-[#6F6F6F]">{{t('Наши ожидания')}}</p>
              <div
                class="text-[#000000] font-sans leading-5 text-xs sm:text-base"
                v-for="item in vacancy.vacancies"
              >
                <p v-html="item.vacancies"></p>
              </div>
            </div>
            <nuxt-link :to="localePath(`/vacancies?id=${vacancy.id}#vacancyForm`)" class="block sm:hidden !mt-4">
              <AButton
                width="medium"
                fontSize="lg"
                class="w-full !rounded-[10px]  justify-end font-medium"
                >{{t('Откликнуться')}}</AButton
              >
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
